import { client } from './client'
import { getCsrf, getCookie } from './authentication'
import { CustomError } from '../CustomError'
import { CSRF_TOKEN_NAME } from '@/constants'

export const createDocumentVersionSession = async (
  documentVersionId: string,
  jsonData: any,
) => {
  await getCsrf()
  const resp = await client.POST(
    '/api/v1/projects/{document_version_id}/document_version_sessions',
    {
      headers: {
        'X-CSRFToken': getCookie(CSRF_TOKEN_NAME),
      },
      params: {
        path: {
          document_version_id: documentVersionId,
        },
      },
      body: {
        json_data: jsonData,
      },
    },
  )

  if (resp.error || !resp.response.ok) {
    const message = 'Failed to create document-version session'
    throw new CustomError(resp, message)
  }

  return resp.data
}

export const getDocumentVersionSession = async (
  documentVersionSessionId: string,
) => {
  const resp = await client.GET(
    '/api/v1/projects/document_version_sessions/{document_version_session_id}',
    {
      params: {
        path: {
          document_version_session_id: documentVersionSessionId,
        },
      },
    },
  )

  if (resp.error || !resp.response.ok) {
    const message = 'Failed to get document-version session'
    throw new CustomError(resp, message)
  }

  return resp.data
}

export const updateDocumentVersionSession = async (
  documentVersionSessionId: string,
  values: {
    json_data: any
    completed: string
  },
) => {
  await getCsrf()
  const resp = await client.PUT(
    '/api/v1/projects/document_version_sessions/{document_version_session_id}',
    {
      headers: {
        'X-CSRFToken': getCookie(CSRF_TOKEN_NAME),
      },
      params: {
        path: {
          document_version_session_id: documentVersionSessionId,
        },
      },
      body: values,
    },
  )

  if (resp.error || !resp.response.ok) {
    const message = 'Failed to update document-version session'
    throw new CustomError(resp, message)
  }

  return resp.data
}
